import { DynamicField, DynamicSections, Facility, PaymentDetailType } from '@cargos/sprintpay-models';
import moment from 'moment';
import { Detail } from '../details';
import { UserPayments } from '../payment/payment';
import { UserProperties } from './user';

export class DSVUser implements UserProperties, UserPayments {
    constructor(
        public dynamicSections: DynamicSections[] = [],
        public dynamicFields: DynamicField[] = [
            {
                name: 'customerRef',
                label: 'Reference',
                section: 2,
                fieldType: 'input',
                company: undefined,
                emailDomain: 'dsv.com',
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage:
                    'Your own personal reference # so you can remember this payment. For example your file #.',
                validations: [
                    {
                        id: 0,
                        name: 'pattern',
                        value: [
                            /^(C|c)([a-zA-Z0-9]{8}|[a-zA-Z0-9]{9})$/,
                            /^(S|s)([a-zA-Z0-9]{10}|[a-zA-Z0-9]{11})$/,
                            /^(B|b)([a-zA-Z0-9]{10}|[a-zA-Z0-9]{11})$/,
                        ],
                        message:
                            'Must start with a C followed by 8-9 alphanumeric characters, or start with an S, followed by 10-11 alphanumeric characters, or must start with a B followed by 10-11 alphanumeric characters.',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 1,
                        name: 'maxlength',
                        value: '255',
                        message: 'Maximum length exceeded (255 characters maximum)',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 2,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter your customer reference.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
        ]
    ) {
        this.dynamicSections = [
            {
                id: 1,
                label: 'Payment Details',
                orderNumber: 1,
                emailDomain: null,
            },
            {
                id: 2,
                label: 'Customer Reference',
                orderNumber: 2,
                emailDomain: null,
            },
        ];
    }

    public getPaymentDetails = (payment: PaymentDetailType, facility: Facility, id: string) => [
        {
            label: facility?.externalLookup
                ? 'File Number'
                : facility?.awbFieldLabel === 'AWB'
                  ? 'RELATED BOL / AWB #'
                  : (facility?.awbFieldLabel ?? 'N/A'),
            value: payment.hawb ? payment.hawb : 'N/A',
            show: !facility.externalLookup && !id,
        },
        {
            label: 'Payment Type',
            value: payment.paymentType ? payment.paymentType : 'N/A',
            show: true,
        },
        { label: 'Paid To', value: payment.paidTo ? payment.paidTo : 'N/A', show: true },
        {
            label: 'Cargo facility',
            value: facility.name ? facility.name : 'N/A',
            show: true,
        },
        {
            label: 'Amount',
            value: payment.amount ? '$' + payment.amount.toFixed(2) : 'N/A',
            show: true,
        },
    ];

    public getPaymentCustomerReference = (payment: PaymentDetailType, customerReferenceLabel: string = '') => [];

    public getCustomerInformation = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Customer Name',
            value: payment.customer ? payment.customer.name : 'N/A',
            show: true,
        },
        {
            label: 'Notification email',
            value: payment?.notificationEmail ? payment?.notificationEmail : 'N/A',
            show: true,
        },
        {
            label: 'Created Date',
            value: payment?.createdDate ? moment(payment?.createdDate).format('MMM DD, YYYY') : 'N/A',
            show: true,
        },
    ];

    public getCompanyCustomerReference = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Payment Amount',
            value: payment?.externalData?.type ?? 'N/A',
            show: true,
        },
        {
            label: 'Type',
            value: payment?.paymentType ?? 'N/A',
            show: true,
        },
        { label: 'Location', value: payment?.location ?? 'N/A', show: true },
    ];
}
